import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;

export function initAppInsights() {
  if (import.meta.env.PROD && !appInsights) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
        enableAutoRouteTracking: true, // Tracks SPA route changes
        disableFetchTracking: false, // capture fetch timings
        disableAjaxTracking: false,
        samplingPercentage: 100, // lower if you need to save $
      },
    });
    appInsights.loadAppInsights();

    // Send a quick “hello” so you can verify ingestion
    appInsights.trackEvent({ name: 'LF FE App Started' });

    // --- Console capture (log / warn / error) ---
    const wrap = (method, severity) => {
      const original = console[method];
      console[method] = function (...args) {
        try {
          const message = args
            .map((a) => {
              if (a instanceof Error)
                return `${a.name}: ${a.message}\n${a.stack || ''}`;
              try {
                return typeof a === 'string' ? a : JSON.stringify(a);
              } catch {
                return String(a);
              }
            })
            .join(' ');
          appInsights.trackTrace({ message, severityLevel: severity });
        } catch {
          // Never block the console
        }
        original.apply(console, args);
      };
    };
    wrap('log', 1);
    wrap('warn', 2);
    wrap('error', 3);

    // --- Global error capture ---
    window.addEventListener('error', (e) => {
      appInsights.trackException({
        exception: e.error || new Error(e.message),
      });
    });
    window.addEventListener('unhandledrejection', (e) => {
      const reason =
        e.reason instanceof Error ? e.reason : new Error(String(e.reason));
      appInsights.trackException({ exception: reason });
    });
  }
  return appInsights;
}
